<div class="itemContainer" *ngIf="!showEditFeature; else editForm">
    <div class="headline">
        <h3>{{ commonFeature.name }}</h3>
        <div class="buttons">
            <button color="primary" style="width: 100%" matButton="elevated" (click)="toggleFeatureEntries()">
                {{ showFeatureEntries ? 'Einklappen' : 'Ausklappen' }}
            </button>
            <button color="accent" style="width: 100%" matButton="elevated" (click)="editFeature()">
                Bearbeiten
            </button>
        </div>
    </div>
    <div *ngIf="showFeatureEntries" class="items">
        <p>
            <b>Filter Option:</b>
            {{ commonFeature.filterOption ? 'Ja' : 'Nein' }}
        </p>
        <p>
            <b>Anzeige auf der Produktdetailseite:</b>
            {{ commonFeature.showDetailPage ? 'Ja' : 'Nein' }}
        </p>

        <p *ngFor="let entry of commonFeature.featureEntries; let i = index">
            <b>Auswahlmöglichkeit {{ i + 1 }}:</b> {{ entry.name }}
        </p>
    </div>
</div>
<ng-template #editForm>
    <app-common-feature-item-edit-form [commonFeature]="commonFeature"
        (close)="onCloseEdit($event)"></app-common-feature-item-edit-form>
</ng-template>